import { render, staticRenderFns } from "./brief.vue?vue&type=template&id=044993ee&scoped=true"
import script from "./brief.vue?vue&type=script&lang=js"
export * from "./brief.vue?vue&type=script&lang=js"
import style0 from "./brief.vue?vue&type=style&index=0&id=044993ee&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../../opt/deploy_node_modules/ailaworld/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "044993ee",
  null
  
)

export default component.exports